import {
  TextsmsOutlined as TextIcon,
  ImageOutlined as ImageIcon,
  VideoCameraBackOutlined as VideoIcon,
  KeyboardVoiceOutlined as AudioIcon,
  GestureOutlined as SignatureIcon,
  ContentPasteSearchOutlined as AccountingIcon,
  FilePresentOutlined as FilesIcon,
  FactCheckOutlined as ChecklistIcon,
  CalendarMonthOutlined as EventIcon,
  Straighten as MeasurementIcon,
  AutoGraph as SalIcon,
} from "@mui/icons-material";
import { ItemType } from "../graphql/types";

// The backend ItemType enum still contains MEETING, but meeting items are no
// longer supported by the web app.
export type SupportedItemType = Exclude<ItemType, ItemType.Meeting>;

export const itemTypeConstants: Record<
  SupportedItemType,
  { icon: any; iconStyle?: any; label: string }
> = {
  [ItemType.Text]: {
    icon: TextIcon,
    label: "itemType.text.translation",
  },
  [ItemType.Images]: {
    icon: ImageIcon,
    label: "itemType.images.translation",
  },
  [ItemType.Video]: {
    icon: VideoIcon,
    label: "itemType.video.translation",
  },
  [ItemType.Audio]: {
    icon: AudioIcon,
    label: "itemType.audio.translation",
  },
  [ItemType.Signature]: {
    icon: SignatureIcon,
    label: "itemType.signature.translation",
  },
  [ItemType.Accounting]: {
    icon: AccountingIcon,
    label: "itemType.accounting.translation",
  },
  [ItemType.Measurement]: {
    icon: MeasurementIcon,
    iconStyle: {
      transform: "rotate(-45deg)",
    },
    label: "itemType.measurement.translation",
  },
  [ItemType.Sal]: {
    icon: SalIcon,
    label: "itemType.sal.translation",
  },
  [ItemType.Files]: {
    icon: FilesIcon,
    label: "itemType.files.translation",
  },
  [ItemType.Checklist]: {
    icon: ChecklistIcon,
    label: "itemType.checklist.translation",
  },
  [ItemType.Event]: {
    icon: EventIcon,
    label: "itemType.event.translation",
  },
};

const itemTypeValues = new Set<string>(Object.keys(itemTypeConstants));

export const toItemType = (type: unknown): SupportedItemType | null => {
  if (typeof type !== "string") return null;
  const normalized = type.toUpperCase();
  return itemTypeValues.has(normalized)
    ? (normalized as SupportedItemType)
    : null;
};
export const getItemTypeTranslationKey = (type: unknown): string | null => {
  const itemType = toItemType(type);
  return itemType ? itemTypeConstants[itemType].label : null;
};
